import kamotu from "@/assets/kamotu.png";


export const services = [
  {
    id: 1,
    title: "車両買取",
    items: ["軽自動車", "普通車", "トラック・バン", "商用車・特殊車両"],
    image: "https://readdy.ai/api/search-image?query=Row%20of%20luxury%20sedan%20cars%20parked%20in%20professional%20dealership%20lot%20evening%20lighting%20clean%20minimal%20background%20automotive%20photography%20high%20end%20vehicles%20dark%20moody%20lighting&width=600&height=400&seq=service-car-01&orientation=landscape",
    icon: "ri-car-line",
  },
  {
    id: 2,
    title: "重機・機械",
    items: ["フォークリフト", "建設機械", "発電機・コンプレッサー", "エンジン・農機具など"],
    image: "https://readdy.ai/api/search-image?query=Yellow%20excavator%20heavy%20construction%20machinery%20on%20industrial%20site%20professional%20equipment%20photography%20clear%20sky%20background%20powerful%20industrial%20machine%20commercial%20photo&width=600&height=400&seq=service-machine-01&orientation=landscape",
    icon: "ri-truck-line",
  },
  {
    id: 3,
    title: "オークション代行",
    items: ["全国オークション対応", "厳選車両の仕入れ", "業者間取引・業販対応"],
    image: "https://readdy.ai/api/search-image?query=Large%20vehicle%20auction%20lot%20with%20hundreds%20of%20cars%20organized%20in%20rows%20aerial%20view%20perspective%20industrial%20auction%20house%20professional%20automotive%20business%20commercial%20photography&width=600&height=400&seq=service-auction-01&orientation=landscape",
    icon: "ri-auction-line",
  },
  {
    id: 4,
    title: "輸出サポート",
    items: ["コンテナ輸出", "海外販売サポート", "通関・書類手続き"],
    image: kamotu,
    icon: "ri-ship-line",
  },
];

export const reasons = [
  {
    id: 1,
    title: "自社積載車完備",
    description: "買取車両は自社積載車で\n安全に引取いたします。",
    icon: "ri-truck-line",
  },
  {
    id: 2,
    title: "全国対応",
    description: "日本全国どこでも\n買取対応いたします。",
    icon: "ri-map-pin-line",
  },
  {
    id: 3,
    title: "豊富な輸出実績",
    description: "世界各国への輸出実績が\n豊富にございます。",
    icon: "ri-global-line",
  },
  {
    id: 4,
    title: "車・重機に強い",
    description: "単両から重機・機械類まで\n幅広く対応可能。",
    icon: "ri-car-washing-line",
  },
  {
    id: 5,
    title: "安心査定",
    description: "無料査定・即日対応で\n安心の取引をお約束。",
    icon: "ri-file-list-3-line",
  },
  {
    id: 6,
    title: "LINEで簡単相談",
    description: "写真を送るだけで\n簡単に査定できます。",
    icon: "ri-chat-1-line",
  },
];

export const companyInfo = {
  name: "中京トレーディング株式会社",
  englishName: "CHUKYO TRADING CO., LTD.",
  description:
    "愛知県名古屋市港区を拠点に、車両・重機・機械類の買取・輸出・業販を専門とする企業です。24時間対応、全国どこへでも出張査定いたします。",
  address: "愛知県名古屋市港区神宮寺２丁目１０２ シャトビオーレ１０２ー2C",
  phone: "090-5615-5500",
  station: "荒子川公園駅 徒歩30分",
  hours: "24時間OK",
  holiday: "なし",
  email: "info@chukyo-trading.com",
  established: "2015年",
  representative: "代表取締役",
};

export const heroImages = {
  background: "https://readdy.ai/api/search-image?query=Car%20carrier%20truck%20transporting%20multiple%20luxury%20vehicles%20at%20sunset%20with%20mountain%20background%20professional%20automotive%20transportation%20dramatic%20lighting%20high%20quality%20commercial%20photography%20navy%20and%20gold%20tones&width=1600&height=900&seq=hero-truck-01&orientation=landscape",
  contact: "https://readdy.ai/api/search-image?query=White%20commercial%20delivery%20truck%20parked%20at%20modern%20warehouse%20facility%20professional%20automotive%20business%20photography%20clean%20industrial%20background%20daylight%20lighting&width=800&height=600&seq=contact-truck-01&orientation=landscape",
};